function initParallaxEffect(observerElementSelector, imageSelector, maxTranslate) {
    const tag = `[Parallax:${observerElementSelector}]`;

    const section = document.querySelector(observerElementSelector);
    const img = section?.querySelector(imageSelector);

    if (!section || !img) {
        console.warn(`${tag} ⛔ Brakuje ${observerElementSelector} lub ${imageSelector}`);
        return;
    }

    let isVisible = false;

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                isVisible = entry.isIntersecting;
            });
        },
        {
            root: null,
            threshold: 0.01,
        }
    );

    observer.observe(section);

    lenis.on('scroll', () => {
        if (!isVisible) return;

        const rect = section.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        let scrollProgress = 1 - rect.top / windowHeight;
        scrollProgress = Math.min(Math.max(scrollProgress, 0), 1);

        const y = -scrollProgress * maxTranslate;
        img.style.transform = `translateY(${y}px)`;
    });
}